import React, { useState } from "react";
import styles from "./button.module.scss";

import classnames from "classnames/bind";
import { noop } from "lodash";
import { KEYS } from "../../utils/listeners";

const classNameBuilder = classnames.bind(styles);

export const Button = ({
  className,
  children,
  dark,
  square,
  selected,
  active,
  onMouseDown: onMouseDownProp = noop,
  onMouseUp: onMouseUpProp = noop,
  onMouseLeave: onMouseLeaveProp = noop,
  rotation,
  icon,
  round,
  fitContent,
  colorful,
  gray,
  spaceDisabled,
  disableMovement,
  disableHover,
  hideBackground,
  transparentBackground,
  large,
  fullWidth,
  presentation,
  whiteText,
  onClick,
  ...rest
}) => {
  const [clicked, setClicked] = useState(false);
  const onMouseDown = (e) => {
    setClicked(true);
    onMouseDownProp(e);
  };
  const onMouseUp = (e) => {
    setClicked(false);
    onMouseUpProp(e);
  };
  const onMouseLeave = (e) => {
    setClicked(false);
    onMouseLeaveProp(e);
  };
  return (
    <button
      className={classNameBuilder("button", className, {
        dark,
        square,
        selected,
        active,
        clicked: clicked && !presentation,
        rotation,
        icon,
        colorful,
        round,
        gray,
        "enable-movement": !disableMovement && !presentation,
        presentation,
        "fit-content": fitContent,
        "enable-hover": !disableHover && !presentation,
        large,
        "full-width": fullWidth,
        "white-text": whiteText,
      })}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      onKeyUp={(e) => {
        if (spaceDisabled && e.code === KEYS.SPACE) {
          e.preventDefault();
        }
      }}
      onClick={presentation ? undefined : onClick}
      {...rest}
    >
      {children}
      {!hideBackground && (
        <div
          className={classNameBuilder("background", {
            dark,
            square,
            selected,
            active: active && !presentation,
            clicked: clicked && !presentation,
            "fit-content": fitContent,
            "transparent-background": transparentBackground,
          })}
        />
      )}
    </button>
  );
};
